var map = {
	"./about-company/about-banner.jpg": 6803,
	"./about-company/people-1.jpg": 8426,
	"./about-company/people-2.jpg": 2472,
	"./about-company/people-3.jpg": 5670,
	"./ceo.jpg": 4260,
	"./kitchen.jpg": 897,
	"./property-1.jpg": 6894,
	"./property-2.jpg": 9832,
	"./property-3.jpg": 2282,
	"./property-4.jpg": 1634,
	"./property-5.jpg": 6252,
	"./service/service.jpg": 8717
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8139;